export function pad(value: string): string {
  const DIGIT_COUNT = 7;
  return String(Math.floor(Number(value))).padStart(DIGIT_COUNT, '0');
}

export function pad6(value: string): string {
  const DIGIT_COUNT = 6;
  return String(Math.round(Number(value))).padStart(DIGIT_COUNT, '0');
}
